import currency from '@common/utility/currency';

export const dateFmt = (date: string) =>
  new Date(date ?? '').toLocaleDateString('en-us', {
    day: 'numeric',
    month: 'short',
    weekday: 'short',
    year: 'numeric',
  });

export const amountFmt = (amt: number | string, abs = true) =>
  currency.format(abs ? Math.abs(Number(amt)) : Number(amt), { maximumFractionDigits: 4 });
